import L from 'leaflet';

// A DivIcon that parses its HTML once and gives each marker a copy of the result, instead of Leaflet's
// `div.innerHTML = html` for every marker it makes. The listing markers' HTML carries the sprite's PNG as a
// data URL (a few kB), so a zoom that redraws a few hundred houses spent most of its marker time parsing the
// same string again and again. The element each marker gets is the same as Leaflet's (same tags, attributes
// and styles); everything else is DivIcon's own createIcon.
const TemplateDivIcon = L.DivIcon.extend({
    createIcon(oldIcon) {
        const { html } = this.options;
        if (typeof html !== 'string') return L.DivIcon.prototype.createIcon.call(this, oldIcon);
        const div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div');
        if (!this._template) {
            const template = document.createElement('div');
            template.innerHTML = html;
            this._template = template;
        }
        const copy = this._template.cloneNode(true);
        div.textContent = '';
        while (copy.firstChild) div.appendChild(copy.firstChild);
        if (this.options.bgPos) {
            const bgPos = L.point(this.options.bgPos);
            div.style.backgroundPosition = `${-bgPos.x}px ${-bgPos.y}px`;
        }
        this._setIconStyles(div, 'icon');
        return div;
    },
});

export const templateDivIcon = (options) => new TemplateDivIcon(options);

export default templateDivIcon;
